import BaseServices from "./BaseServices";

const InvoiceServices = {
    GetInvoiceOrderModelsAsync: async (paging) => {
        return await BaseServices.Post("/api/invoice/get-invoice-order-models", paging);
    },
    GetInfoHistoryById: async (originalInvoiceId) => {
        return await BaseServices.Get(`/api/invoice/get-info-history-by-id/${originalInvoiceId}`);
    },
    CreateDraftInvoice: async (originalInvoiceId) => {
        return await BaseServices.Post(`/api/invoice/create-draft-invoice/${originalInvoiceId}`);
    },
    PublishInvoice: async (invoiceId) => {
        return await BaseServices.Post(`/api/invoice/publish-invoice/${invoiceId}`);
    },
    ExportInvoiceFile: async (invoiceId) => {
        return await BaseServices.Get(`/api/invoice/export-invoice-file/${invoiceId}`);
    },
    SyncFileByTransactionUUID: async (originalInvoiceId) => {
        return await BaseServices.Get(`/api/invoice/sync-file-by-transaction-uuid/${originalInvoiceId}`);
    },
    UpdateInfoHistory: async (model) => {
        return await BaseServices.Post(`/api/invoice/update-info-history`, model);
    },
    ModifyInvoice: async (model, reasonId) => {
        return await BaseServices.Post(`/api/invoice/modify-invoice/${reasonId}`, model);
    },
    CheckInvoiceModified: async (originalInvoiceId) => {
        return await BaseServices.Get(`/api/invoice/check-invoice-modified/${originalInvoiceId}`);
    },
};

export default InvoiceServices;
